// App.js – Wurzelkomponente: Router, Sprunglink, Navigation, Routen, Fußzeile und Cookie-Banner.
// Neue Seite: Import und <Route> hier ergänzen (weitere Schritte: docs/ENTWICKLUNG-WEBSITE.md).
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css"; // Farbsystem und Schriften (nach Bootstrap, damit sie dessen Standardwerte überschreiben)
import Top from "./components/Navbar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/pages/Home";
import Kontakt from "./components/pages/Kontakt";
import Datenschutz from "./components/pages/Datenschutz";
import Impressum from "./components/pages/Impressum";
import InfoBaumpflege from "./components/pages/InfoBaumpflege";
import InfoMulchen from "./components/pages/InfoMulchen";
import InfoBaumfaellung from "./components/pages/InfoBaumfaellung";
import UeberMich from "./components/pages/UeberMich";
import Referenzen from "./components/pages/Referenzen";
import Einsatzgebiet from "./components/pages/Einsatzgebiet";
import FAQ from "./components/pages/FAQ";
import NotFound from "./components/pages/NotFound";
import Footer from "./Footer";
import { Banner } from "./Banner";
import { BetriebSchema } from "./components/Strukturdaten";

// Fokus ausdrücklich auf den Inhalt setzen: Ein reiner Sprung zu #inhalt verschiebt in Chrome den Tastaturfokus
// nicht zuverlässig, und die Adresse bekäme sonst ein „#inhalt“ angehängt.
function zumInhalt(e) {
  const inhalt = document.getElementById("inhalt");
  if (!inhalt) return;
  e.preventDefault();
  inhalt.focus();
}

function App() {
  return (
    <Router>
      {/* Sprunglink für Tastatur und Screenreader: erst bei Fokus sichtbar (Stil in App.css) */}
      <a href="#inhalt" className="ff-skip-link" onClick={zumInhalt}>
        Zum Inhalt
      </a>
      <Top />
      {/* Strukturdaten des Betriebs (JSON-LD) auf jeder Seite; Werte aus src/data/betrieb.js */}
      <BetriebSchema />

      <main id="inhalt" tabIndex={-1}>
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/kontakt" element={<Kontakt />}></Route>
          <Route path="/datenschutz" element={<Datenschutz />}></Route>
          <Route path="/impressum" element={<Impressum />}></Route>
          <Route path="/baumpflege" element={<InfoBaumpflege />}></Route>
          <Route path="/mulchen" element={<InfoMulchen />}></Route>
          <Route path="/baumfaellung" element={<InfoBaumfaellung />}></Route>
          <Route path="/ueber-mich" element={<UeberMich />}></Route>
          <Route path="/referenzen" element={<Referenzen />}></Route>
          <Route path="/einsatzgebiet" element={<Einsatzgebiet />}></Route>
          <Route path="/faq" element={<FAQ />}></Route>
          {/* Alle übrigen Adressen: Fehlerseite (nginx liefert dafür Status 404, siehe docker/nginx.conf) */}
          <Route path="*" element={<NotFound />}></Route>
        </Routes>
      </main>

      <Footer />
      <Banner />
    </Router>
  );
}

export default App;
